import { render } from "./Step0.vue?vue&type=template&id=1223d48f"
import script from "./Step0.vue?vue&type=script&lang=js"
export * from "./Step0.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__